var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-multiselect',{class:_vm.sizeClass,attrs:{"value":_vm.selectedOption,"options":_vm.options,"label":"label","track-by":"value","searchable":false,"allow-empty":false,"select-label":"","deselect-label":"","selected-label":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71e1f856","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Nominations/components/NominationListSelect.vue
// module id = 1337
// module chunks = 0